import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AiSourcingService } from 'src/app/_services/ai-sourcing.service';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { LoginService } from 'src/app/_services/login.service';
import * as _ from 'underscore';


@Component({
    selector: 'app-share-project',
    templateUrl: './share-project.component.html',
    styleUrls: ['./share-project.component.scss'],
    standalone: false
})
export class ShareProjectComponent implements OnInit {

  currentUserId: string = null;
  allTeamMembers: any[] = [];
  shareErrorMessage: string = null;
  selectedMembers: any[] = [];
  revokedMembers: any[] = [];
  @Input() selectedProject: any = null;
  successMessage: string = null;
  errorMessage: string = null;

  constructor(private loginService: LoginService, private localstorageService: LocalStorageService,
    private modalService: NgbModal, private aiSourcingService: AiSourcingService, private activeModal: NgbActiveModal
  ) { }

  ngOnInit() {
    this.getAllTeamMembers();
    this.currentUserId = this.localstorageService.getItem('usernumber');

  }

  getAllTeamMembers() {
    this.aiSourcingService.getAutopilotUsers(this.selectedProject?.projectnumber).subscribe((res: any) => {
      if (res && res.status === 'success') {
        const allMembers: any[] = res?.data || [];
        this.allTeamMembers = allMembers;
      }
    })
  }

  changeMemberSelection(event, member) {
    this.shareErrorMessage = '';
    const checked = (event.target as HTMLInputElement).checked;
    member.projectshared = checked;
    if (checked) {
      this.selectedMembers.push(member);
    } else {
      this.selectedMembers = this.selectedMembers.filter(mem => mem.usernumber != member.usernumber);
      const memebers = this.allTeamMembers.find(m => m.usernumber == member.usernumber);
      if (memebers) {
      this.revokedMembers.push(member.usernumber);
      }
    }
    this.selectedMembers = _.uniq(this.selectedMembers, 'usernumber');
  }

  closeModal(type: string, message?: any) {
  if(type == 'error') {
      this.activeModal.dismiss(message);
    } else {
      this.activeModal.close(type == 'skip' ? 'user-dismissed' : message ? message : null);
    }
  }

  shareProject() {
    const granted = _.pluck(this.selectedMembers, 'usernumber');
    const revoked = this.revokedMembers;
    const disableShareButton = granted.length == 0 && revoked.length == 0;
    this.shareErrorMessage = disableShareButton ? 'Please select or deselect at least one member to share the talentpool with.' : '';
    if(disableShareButton) return;

    const payload = {
      projectnumber: this.selectedProject?.projectnumber,
      grant: granted,
      revoke: revoked
    }
    this.aiSourcingService.shareProject(payload).subscribe((res: any) => {
      if (res && res.status === 'success') {
          this.closeModal('success', `Project shared successfully to user`);

      } else {
          this.closeModal('error');

      }
    });
  }


}
